import React from "react";
import { Switch, Form, Tooltip } from "antd";
import { userUseMutation } from "../hooks";
import { Localize } from "components/service";
import { EUserStatus, TUser } from "components/user/helpers/user-types-helper";
import { usePermissionByObject } from "components/permissions";
import UserConst from "../users-const";
import { localizeByKeyStatic } from "components/service/localize";

type TUserStatusFieldProps = {
  id: TUser["id"];
  status: EUserStatus;
};

const UserStatusField: React.FC<TUserStatusFieldProps> = ({ id, status }) => {
  const [form] = Form.useForm();
  const [statusValue, setStatusValue] = React.useState(status === EUserStatus.ACTIVE);

  const { _setUserCreateUpdate } = userUseMutation.createUpdate(id, false);
  const { hasPermission: hasChangeStatusPermission } = usePermissionByObject(UserConst.permissions.CHANGE_STATUS);


  return (
    <Form form={form} className="">
      <div className="switch-holder">
        <Form.Item
          name="status"
          initialValue={status === EUserStatus.ACTIVE}
          style={{ marginBottom: 0 }}
        >
          <Tooltip
            title={!hasChangeStatusPermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(UserConst.permissions.CHANGE_STATUS.slug)}` : undefined}
          >
            <Switch
              checked={statusValue}
              disabled={!hasChangeStatusPermission}
              onChange={(checked) => {
                if (!hasChangeStatusPermission) return;

                setStatusValue(checked);
                _setUserCreateUpdate({
                  variables: {
                    input: {
                      id,
                      status: checked ? EUserStatus.ACTIVE : EUserStatus.BLOCK,
                    },
                  },
                });
              }}
            />
          </Tooltip>
        </Form.Item>

        {statusValue ? (
          <span
            style={{ color: "var(--switch_colorPrimary)" }}
            className="switch-status-text"
          >
            <Localize>GLOBAL.Text_Active</Localize>
          </span>
        ) : (
          <span
            style={{ color: "var(--switch_colorTextQuaternary)" }}
            className="switch-status-text"
          >
            <Localize>GLOBAL.Text_Blocked</Localize>
          </span>
        )}
      </div>
    </Form>
  );
};

export default UserStatusField;
